import { render, staticRenderFns } from "./VersionNote.vue?vue&type=template&id=6823d944&scoped=true&"
import script from "./VersionNote.vue?vue&type=script&lang=js&"
export * from "./VersionNote.vue?vue&type=script&lang=js&"
import style0 from "./VersionNote.vue?vue&type=style&index=0&id=6823d944&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6823d944",
  null
  
)

export default component.exports